import { css } from '@emotion/react';
import type { CSSInterpolation } from '@emotion/serialize';
import type { ReactNode } from 'react';

import IconEmoticonDeadOutline from '~icons/mdi/emoticon-dead-outline';

import { theme, typography } from '@adflow/frontend/ui-theme';

const styles = {
	container: css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
	}),
	icon: css({
		width: '100%',
		height: '100%',
		marginLeft: 'auto',
		marginRight: 'auto',
		maxWidth: '4rem',
		maxHeight: '4rem',
		color: theme.colors.text.hint,
	}),
	message: css(typography.emptyLarge, {
		textAlign: 'center',
		maxWidth: '20rem',
	}),
};

export interface ErrorIndicatorProps {
	message?: ReactNode;
	containerStyle?: CSSInterpolation;
}

/** Indicate that an error has occurred by displaying an icon in the center of the container. */
export function ErrorIndicator({
	message,
	containerStyle,
}: ErrorIndicatorProps) {
	return (
		<div css={[styles.container, containerStyle]}>
			<IconEmoticonDeadOutline css={styles.icon} />
			{message ? <div css={styles.message}>{message}</div> : null}
		</div>
	);
}
